import type { BaseCabsEvent } from "./xdmSchema";

/**
 * Fetches SEO XDM payload for current page.
 * Call on SEO pages; pass result to logEventToXDM.
 */
export async function fetchSeoXdmPayload(): Promise<BaseCabsEvent | null> {
  try {
    const SEO_XDM_PAYLOAD_API = `${__ENV_CONFIG__['__GOCARS__']}/api/seo-xdm-payload`;
    const pageUrl = typeof window !== 'undefined' && window.location.href ? window.location.href : "";

    const res = await fetch(SEO_XDM_PAYLOAD_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: pageUrl }),
    });

    if (!res.ok) return null;

    const payload = await res.json();
    return payload;
  } catch {
    return null;
  }
}
